<div class="card card-custom gutter-b">
    <!--Card Header-->
    <div class="card-header">
        <div class="card-title">
            <h1 class="card-label">
                <span>Terms and Conditions</span>
            </h1>
        </div>
    </div>


    <!--Card Body-->
    <div class="card-body">

        <div class="mt-5">
            <div class="scroll-container blue-scroll-bar">
                <p>In Progress</p>
        </div>
    </div>
</div>
